module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXBAMAAAAIOCkdAAAAAXNSR0IB2cksfwAAABhQTFRFAAAAADBQADVVADVVADRUADVUADVUADVT+c0vDgAAAAh0Uk5TABA/MED/wJCaTetLAAAAKklEQVR4nGNggAMhJSUDBI/BNTQ0YWC5YAchuGAWEVyENvoSZmlpBQgCAH/VOPKRhTi9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--analytics.png
// module id = 919
// module chunks = 0